module.exports = __webpack_public_path__ + "static/media/paso2compra.499bd29e.svg";